import Head from "next/head";

type MainForm = {
  title: string;
  breadcrumb?: string;
  description?: string;
  component: any;
  padding?: boolean;
  mainClass?: string;
};

const makeForm = ({ title, breadcrumb, description, component, padding = true, mainClass }: MainForm) => {
  return (
    <>
      <Head>
        <title>{title}</title>
      </Head>
      <div className={mainClass ? mainClass : "p-8"}>
        {/* 페이지 타이틀 영역*/}
        <div className="">
          <span className="text-2xl font-semibold text-gray-700">{title}</span>
          <span className="ml-4 text-sm text-gray-600">{breadcrumb}</span>
        </div>
        <div className="text-sm mt-3 text-gray-700">{description}</div>

        {/*페이지 컨텐츠 영역*/}
        <div className="mt-6">
          {/*<div className={`rounded-xl border border-gray-100 ${padding ? "p-6" : "py-6"}`}>{component}</div>*/}
          <div className={`card ${padding ? "" : "grid"}`}>{component}</div>
        </div>
      </div>
    </>
  );
};

export default makeForm;
